import communicationApi from "./communication.api";
import qb from "./query.builder";
import auth from "./auth";
//import Router from 'vue-router';
// import store2 from 'store2';

function wMsg() {
	this.Status = 0;
	this.Description = "";
	this.Body = null;
}

function msg_box(msg_type, msg) {
	var msgbox = {
		show: true,
		text: msg,
		color: msg_type,
		timeout: 6000
	};

	// @ts-ignore
	window.MainApp.$root.$children[0].msgbox = msgbox;
}

function Success(msg) {
	msg_box("success", msg);
}

function Error(msg) {
	msg_box("error", msg);
}

function Info(msg) {
	msg_box("info", msg);
}

async function getGeneralOptions(class_name, column_name, field_selected = []) {
	let result = [];
	let cls_qb = new qb.QueryBuilder();

	cls_qb.Table = "hrm_appgeneraloption";
	cls_qb.Method = "all";

	let rule = new qb.Rule();
	rule.field("class_name").operator(qb.STR_OPERATOR.EQUAL).value(class_name);
	cls_qb.addRule(rule)

	rule = new qb.Rule();
	rule.field("column_name").operator(qb.STR_OPERATOR.EQUAL).value(column_name);
	cls_qb.addRule(rule)

	cls_qb.Select = field_selected;

	let res = await PostData("process_qb/", cls_qb);

	if (res.data.Status == 1) {
		result = res.data.Body.records;
	}
	return result;
}

function update_obj_property_value(from_obj, to_obj){
	return Object.assign({},from_obj, to_obj);
}

function checkInvalidUserError(w_msg) {
	if (w_msg.data.Status == 4) {
		switch (w_msg.data.Description) {
			case "token is expired (exp)":  // auth waterteh
			case "token not valid yet (nbf)": // auth waterteh
			case "invalid ticket parse": // auth waterteh
			case "invalid ticket descrypt": // auth waterteh
			case "invalid ticket claim": // auth waterteh
			case "Invalid user": // existing HRM code // case "ticket not valid yet or expired":
			case "Authenticate token expired": // existing HRM code
				auth.logout();
				w_msg = "";
				break;
			case "User profile aging >90 days":
				// window.location.href = "/change_pw?pageid=138";
				window.location.href = "/change_pw?uuid=bf1814a7-32b1-4389-8ff2-c837a24e4089";
				break; // route to change pw url
		}
	}
	return w_msg;
}

async function GetData(url) {
	let msg_res = await communicationApi.getData(url);

	return checkInvalidUserError(msg_res);
}

async function PostData(url, data) {
	let msg = new wMsg();
	let currentDateTime = new Date().toLocaleString();

	msg.Status = 1;
	msg.Description = `Send at ${currentDateTime}`;
	msg.Body = data;

	let msg_res = await communicationApi.postMsg(url, msg);

	return checkInvalidUserError(msg_res);
}

async function PutData(url, data) {
	let msg = new wMsg();
	let currentDateTime = new Date().toLocaleString();

	msg.Status = 1;
	msg.Description = `Send at ${currentDateTime}`;
	msg.Body = data;

	let msg_res = await communicationApi.putMsg(url, msg);

	return checkInvalidUserError(msg_res);
}

async function arango_app_selections(class_name, column_name) {
	let result = [];
	let url = `fpes/get_app_selections/?class_name=${class_name}&column_name=${column_name}`;
	var temp  = await GetData(url);

	if (temp.data.Status==1){
		result = temp.data.Body.records;
	}
	return result
}

function check2digits(int_value) {
	var ret_value = int_value;

	if (int_value < 10) {
		ret_value = "0" + ret_value;
	}

	return ret_value;
}

function to_locale_datetime(date) {
	var current_datetime = new Date(date);
	let formatted_date = current_datetime.getFullYear() + "-"
		+ check2digits((current_datetime.getMonth() + 1))
		+ "-" + check2digits(current_datetime.getDate())
		+ " " + check2digits(current_datetime.getHours())
		+ ":" + check2digits(current_datetime.getMinutes())
		+ ":" + check2digits(current_datetime.getSeconds())

	return formatted_date;
}

async function DeleteData(url, data) {
	// let msg = new wMsg();
	// let currentDateTime = new Date().toLocaleString();

	// msg.Status = 1;
	// msg.Description = `Send at ${currentDateTime}`;
	// msg.Body = data;

	let msg_res = await communicationApi.deleteMsg(url, data);

	return checkInvalidUserError(msg_res);
}

// str_datetime2epoch("2019-09-04 08:00:00")
function get_str_datetime2epoch(str_datetime) {
	return (new Date(str_datetime)).getTime() / 1000;
}

function epoch2LocaleDatetime(text) {
	var temp = "";

	if (text > 0) {
		temp = to_locale_datetime(new Date(text * 1000).toISOString());
	}
	return temp;
}

function get_current_datetime_in_epoch() {
	return new Date().getTime()/1000;
}

function get_pageID(uuid) {
	// var url = new URLSearchParams(window.location.search);
	// var pageID = url.get("pageid");
	// return pageID;
	var menu = auth.getMenu().concat(auth.getMenu_int());
	let res = 1;

	if (uuid != null) {
		let temp = menu.filter(rec => rec.uuid == uuid);
		res = temp[0].id;
	}

	return res;
}

function get_pageID_str(uuid) {
	return String(get_pageID(uuid));
}

function get_searchParams(str) {
	var url = new URLSearchParams(window.location.search);
	return url.get(str);
}

function get_pageUUID() {
	// var url = new URLSearchParams(window.location.search);
	// var pageUUID = url.get("uuid");
	// return pageUUID;
	return get_searchParams("uuid");
}

// function getAppMenu(home_id) {
// 	var menu = auth.getMenu().concat(auth.getMenu_int());

// 	if (home_id) {
// 		let temp = menu.filter(function (rec) {
// 			return rec.parent_page_id == home_id;
// 		});
// 		return temp;

// 	} else {
// 		let temp = menu.filter(function (rec) {
// 			return rec.parent_page_id == null && rec.display_text != null;
// 		});
// 		return temp;
// 	}
// }

function getAppMenu(home_uuid, rec_order_desc) {
  var menu1 = auth.getMenu();
	var menu2 = auth.getMenu_int();

	if (rec_order_desc == "true") {
		// decsending
		menu1.sort((a, b) => b.order - a.order);
		menu2.sort((a, b) => b.order - a.order);
  } else {
		//ascending
		menu1.sort((a, b) => a.order - b.order);
		menu2.sort((a, b) => a.order - b.order);
  }

	var menu = menu1.concat(menu2);

	// var menu = auth.getMenu().concat(auth.getMenu_int());
	let res = [];

	if (home_uuid == null) {
		// for home-page.
		let temp = menu.filter(function (rec) {
			return rec.parent_page_id == null && rec.display_text != null;
		});
		res = temp;

	} else {
		let thisMenu = menu.filter(item => item.uuid == home_uuid);
		let ids = new Set(thisMenu.map(m => m.id));
		res = menu.filter(rec => ids.has(rec.parent_page_id));
	}

	return res;
}

function showLoader(el){
	el.$root.$children[0].loader.show = true;
}

function hideLoader(el){
	el.$root.$children[0].loader.show = false;
}

function getQueryString(key, default_value = null) {
	var url = new URL(window.location.href);
	var params = url.searchParams;
	var val = params.get(key);
	if (val == null) {
		val = default_value;
	} else if (val.length == 0) {
		val = default_value;
	}
	return val;
}

function set_page_title(title){
	document.title = title;
}

// async function get_breadcrumb(page_id) {
// 	let menu = auth.getMenu().concat(auth.getMenu_int());

// 	let breadcrumbs = menu.filter(function (AppMenu) {
// 		return AppMenu.id == page_id;
// 	});

// 	if (breadcrumbs.length == 0) {
// 		return [];
// 	}

// 	var n = 1;
// 	for (var i = 0; i < n; i++) {
// 		var tt = breadcrumbs[i]["parent_page_id"];
// 		var temp1 = [];
// 		if (tt) {
// 			temp1 = menu.filter(function (AppMenu) {
// 				return AppMenu.id == tt;
// 			});
// 			breadcrumbs = breadcrumbs.concat(temp1);
// 			n += 1;
// 		}
// 	}

// 	return breadcrumbs.reverse();

// }

function get_breadcrumb(page_uuid, menu) {
	// let menu = auth.getMenu().concat(auth.getMenu_int());

	let breadcrumbs = menu.filter(function (AppMenu) {
		return AppMenu.uuid == page_uuid;
	});

	if (breadcrumbs.length == 0) {
		return [];
	}

	var n = 1;
	for (var i = 0; i < n; i++) {
		var tt = breadcrumbs[i]["parent_page_id"];
		var temp1 = [];
		if (tt) {
			temp1 = menu.find((el) => el.id == tt);
			if (temp1 != undefined) {
				breadcrumbs = breadcrumbs.concat(temp1);
				n += 1;
			}
		}
	}

	// return breadcrumbs.reverse();
	return breadcrumbs;
}

async function get_breadcrumb_arg(_id, djg_menu) {
	let menus = [];

	let cls_qb = new qb.QueryBuilder();
	// qb.Table = "file_upload_listing";
  // qb.Select = [{value:"name"},{value:"g_status_id"}]
  // must check sortBy before push in order array
  // qb.Order = [
	// 	{
	// 		name: "order",
	// 		descending: true,
	// 	}
	// ]
  // let rule = new query_builder.Rule();
  // rule
  //   .field("_id")
  //   .operator(query_builder.A_STR_OPERATOR.EQUAL)
  //   .value(_id);
  // qb.Where.rules.push(rule)
  cls_qb.Offset = 1
  let res = await PostData("process_arango_qb_asset/", cls_qb);
	res = res.data;
	if (res.Status == 1) {
    menus = res.Body[0].records;

		let len = menus.length;
    for (let m = 0; m < len; m++) {
      var el = menus[m];
      el.component_path = el.component_path? JSON.parse(el.component_path): "";
    }

	} else {
		Error(res.Description);
	}

	let breadcrumbs = menus.filter(function (AppMenu) {
		return AppMenu._id == _id;
	});

	if (breadcrumbs.length == 0) {
		return [];
	}

	var n = 1;
	var tt = "";
	for (var i = 0; i < n; i++) {
		tt = breadcrumbs[i]["parent_page_id"];
		var temp1 = [];
		if (tt) {
			temp1 = menus.find((el) => el._id == tt);
			if (temp1 != undefined) {
				breadcrumbs = breadcrumbs.concat(temp1);
				n += 1;
			}
		}
	}

	// obtain breadcrumb from djangoDB
	let last_arr_obj = breadcrumbs[breadcrumbs.length-1];
	let temp_parentID = last_arr_obj["parent_page_id"];
	temp_parentID = parseInt(temp_parentID);
	let temp_parentObj = djg_menu.find((el) => el.id == temp_parentID);

	let djg_breadcrumbs = get_breadcrumb(temp_parentObj["uuid"], djg_menu);

	// join both breadcrumb
	breadcrumbs = breadcrumbs.concat(djg_breadcrumbs);
	
	return breadcrumbs;
}

function get_share_link(path) {
    let result = "";
    if (path.match("http")) {
        result = path;
    } else {
        result = location.origin + "/" + path;
    }
    return result;
}

function check_role(role_list, role_id){
	let result = false;
	let len = role_list.length;

	for (let i=0; i<len; i++) {
		if (role_list[i]["id"] == role_id) {
			result = true;
			break;
		}
	}
	return result
}

function getEventsMemberGlobalID(){
	let mode = communicationApi.MODE;
	let setting = {
		"local":"app_selections/96473884",
		"dev":"app_selections/96473884",
		"prod":"app_selections/100621093",
	}
	// NOTE: return matching key, or fallback to local
	return setting[mode] || setting.local;
}

export default {
	wMsg,
	wMsgBox: {
		Success,
		Error,
		Info
	},
	wBackEndComm: {
		GetData,
		PostData,
		PutData,
		DeleteData
	},
	App: {
		getGeneralOptions,
		get_str_datetime2epoch,
		to_locale_datetime,
		get_pageID,
		get_pageID_str,
		get_pageUUID,
		get_searchParams,
		getAppMenu,
		get_breadcrumb,
		get_breadcrumb_arg,
		arango_app_selections,
		get_current_datetime_in_epoch,
		getQueryString,
		epoch2LocaleDatetime,
		set_page_title,
		loader:{
			show:showLoader,
			hide:hideLoader
		},
		get_share_link,
		// arangoDB_general_option, // to remove after 2024 Apr
		check_role,
		update_obj_property_value
	},
	Setting: {
		getEventsMemberGlobalID
	}
}